import { Navigate } from "react-router-dom";
import { TOKEN_KEY } from "../../utils/request";

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
